import { useEffect, useState } from "react";
import {
  Box, Typography, Card, CardContent,
  TextField, Button, Chip
} from "@mui/material";
import { db } from "../firebase";
import { ref, get, set } from "firebase/database";

export default function Settings() {
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [depInput, setDepInput] = useState("");
  const [desInput, setDesInput] = useState("");

  useEffect(() => {
    (async () => {
      const depSnap = await get(ref(db, "/masters/departments"));
      const desSnap = await get(ref(db, "/masters/designations"));
      setDepartments(depSnap.val() || []);
      setDesignations(desSnap.val() || []);
    })();
  }, []);

  const save = async () => {
    await set(ref(db, "/masters/departments"), departments);
    await set(ref(db, "/masters/designations"), designations);
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        Settings
      </Typography>

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 700 }}>
            Departments
          </Typography>

          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
            {departments.map((d, i) => (
              <Chip
                key={`${d}-${i}`}
                label={d}
                onDelete={() =>
                  setDepartments(departments.filter((_, k) => k !== i))
                }
              />
            ))}
          </Box>

          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              size="small"
              label="Add department"
              value={depInput}
              onChange={(e) => setDepInput(e.target.value)}
            />
            <Button
              onClick={() => {
                const v = depInput.trim();
                if (!v) return;
                if (!departments.includes(v)) {
                  setDepartments([...departments, v]);
                }
                setDepInput("");
              }}
            >
              Add
            </Button>
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 700 }}>
            Designations
          </Typography>

          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
            {designations.map((d, i) => (
              <Chip
                key={`${d}-${i}`}
                label={d}
                onDelete={() =>
                  setDesignations(designations.filter((_, k) => k !== i))
                }
              />
            ))}
          </Box>

          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              size="small"
              label="Add designation"
              value={desInput}
              onChange={(e) => setDesInput(e.target.value)}
            />
            <Button
              onClick={() => {
                const v = desInput.trim();
                if (!v) return;
                if (!designations.includes(v)) {
                  setDesignations([...designations, v]);
                }
                setDesInput("");
              }}
            >
              Add
            </Button>
          </Box>

          <Box sx={{ mt: 2 }}>
            <Button variant="contained" onClick={save}>
              Save Masters
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
